__turbopack_context__.v({
  "freeBox": "PlasmicLabel-module__MwmKwq__freeBox",
  "root": "PlasmicLabel-module__MwmKwq__root",
  "rootweightAndColor_boldBlack": "PlasmicLabel-module__MwmKwq__rootweightAndColor_boldBlack",
  "rootweightAndColor_boldWhite": "PlasmicLabel-module__MwmKwq__rootweightAndColor_boldWhite",
  "rootweightAndColor_normalWhite": "PlasmicLabel-module__MwmKwq__rootweightAndColor_normalWhite",
  "slotTargetChildren": "PlasmicLabel-module__MwmKwq__slotTargetChildren",
  "text": "PlasmicLabel-module__MwmKwq__text",
});
